const DriverInfoSection = ({ driver, vehicle }) => {
  return (
    <div className=" md:w-[48%] w-full bg-third rounded-3xl p-6 font-semibold flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h3 className="text-xl text-gray-400">Driver Info:</h3>
      </div>
      <div className="flex flex-col gap-3">
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Full Name:</span>
          {driver?.full_name}
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Phone Number:</span>
          {driver?.phone_number}
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Vehicle Name:</span>
          {vehicle?.company}
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Vehicle Model:</span>
          {vehicle?.model}
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Plate Number:</span>
          {vehicle?.plate_number}
        </p>
        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Vehicle Color:</span>
          {vehicle?.color}
        </p>

        <p className="flex items-center gap-2 text-black">
          <span className="text-gray-400">Vehicle Status:</span>
          {vehicle?.status}
        </p>
      </div>
    </div>
  );
};

export default DriverInfoSection;
